module.exports = __webpack_public_path__ + "img/hyj4.f12777e4.png";